import { State } from 'store/state';
import { createSelector } from 'reselect';


// tslint:disable-next-line: variable-name
const __abTestsStateSelector = (state: State) => state.abTests;
export const abTestsStateSelector = createSelector(__abTestsStateSelector, (s) => s);

